/* eslint-disable react/no-array-index-key */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
import React, { useState } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import SPform from 'src/components/SpareParts/SPform/SPform'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import Card from '@auteco/components/sharedComponents/Card/Card'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import CardHeader from '@auteco/components/sharedComponents/Card/CardHeader'
import { Chart } from 'react-chartjs-2'

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import currencyFormat from '@auteco/utils/formatCOP'
import SpTopTen from 'src/components/SpareParts/SpTopTen/SpTopTen'
import SpAplicationModel from '@auteco/components/SpareParts/SpAplicationModel/SpAlicationModel'

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
)

const axixPros = {
  display: true,
  color: '#000',
  font: {
    size: 30,
    style: 'normal',
    lineHeight: 1.2,
    family: 'nunito',
  },
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow)

const useStyles = makeStyles(() => ({
  cardLegend: {
    justifyContent: 'center',
    margin: 20,
    fontSize: 30,
  },
  table: {
    minWidth: 700,
  },
  tableContainer: {
    margin: 10,
  },
  chartDaysContainer: {
    maxWidth: '1100px',
    margin: '0 auto'
  }
}))

const sumatorySimpleArray = (array) =>
  array?.reduce(
    (previousValue, currentValue) =>
      Number(previousValue) + Number(currentValue),
    0,
  )

const SparePartsPage = ({
  filters,
  onSubmitForm,
  graphicData,
  graphicDataDays,
  topTen,
  forms,
  models,
  handleDisplayUnits,
  handleDisplayDays
}) => {
  const classes = useStyles()
  const [resetKey, setResetKey] = useState(false)

  const formatGraphicData = (data) => {
    const object = { ...data }
    const formated = object.datasets.filter(el => el.label !== 'Back order')
    object.datasets = formated
    return object
  }


  const generateOptsLine = (name, funct) => ({
    responsive: true,
    maintainAspectRatio: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    tooltips: {
      mode: 'index',
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: 'right',
        onClick: (e, legendItem, legend) =>
          funct(legendItem, legend),
      },
    },
    stacked: true,
    scales: {
      y: {
        id: 'y-axis-0',
        display: true,
        position: 'left',
        title: {
          text: name,
          ...axixPros,
        }
      },
      categoryScale: 0.1,
      categoryPercentage: 0.2,
    },
  })

  const combinedGraphics = graphicData?.datasets.concat(graphicDataDays.datasets)

  let rows = []
  rows = combinedGraphics.map((element) => ({
    datos: element.data,
    name: element.label,
    backgroundColor: element.backgroundColor,
    table: element.table,
    total: sumatorySimpleArray(element.table),
  }))
  const top = topTen.map((el) => el.Material)
  return (
    <>
      <CardTitle title="Analizador de Repuestos" />
      {filters?.length > 0 ? (
        <SPform
          filters={filters}
          onSubmitForm={(form) => {
            onSubmitForm(form, true), setResetKey(!resetKey)
          }}
        />
      ) : null}
      <Card>
        <CardHeader>
          <div className={classes.cardLegend}>
            <b>Gráfica tendencia inventario</b>
          </div>
        </CardHeader>
        {models?.length > 0 ? (
          <>
            <div style={{ margin: 10 }}>
              <p>Filtro por modelos de aplicación</p>
            </div>
            <SpAplicationModel
              forms={forms}
              key={resetKey}
              models={models}
              onSubmitForm={onSubmitForm}
            />
          </>
        ) : null}
        {top[0] !== undefined ? (
          <>
            <div style={{ margin: 10 }}>
              <p>Filtro por material</p>
            </div>
            <SpTopTen
              forms={forms}
              key={resetKey}
              topTen={topTen}
              onSubmitForm={onSubmitForm}
            />
          </>
        ) : null}
        <CardBody>
          <div>
            <Chart type="bar" data={formatGraphicData(graphicData)} options={generateOptsLine('Unidades', handleDisplayUnits)} style={{ height: '400px' }} />
          </div>
          <br />
          <br />
          <div className={classes.chartDaysContainer}>
            <Chart type="bar" data={formatGraphicData(graphicDataDays)} options={generateOptsLine('Días', handleDisplayDays)} style={{ height: '400px' }} />
          </div>
          <div className={classes.tableContainer}>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell> </StyledTableCell>
                    {graphicData.labels.map((row, i) => (
                      <StyledTableCell key={i}>{row}</StyledTableCell>
                    ))}
                    <StyledTableCell>TOTAL</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, i) => (
                    <StyledTableRow
                      key={i}
                      style={{
                        backgroundColor: row.backgroundColor,
                        borderColor: row.backgroundColor,
                        borderWidth: 2,
                      }}
                    >
                      <StyledTableCell component="th" scope="row">
                        {row.name}
                      </StyledTableCell>
                      {row.table.map((dato, index) => (
                        <StyledTableCell align="right" key={index}>
                          {dato !== 'NaN' ? currencyFormat(parseInt(dato || 0, 10)) : 0}
                        </StyledTableCell>
                      ))}
                      <StyledTableCell component="th" scope="row">
                        {row.name.slice(0, 4) === 'Días'
                          ? row.table.at(-1)
                          // ? parseInt(row.total || 0, 10)
                          : currencyFormat(parseInt(row.total || 0, 10))}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </CardBody>
      </Card >
    </>
  )
}

export default SparePartsPage
